import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { AlertService } from 'app/shared/services/alert.service';
var LoginComponent = /** @class */ (function () {
    function LoginComponent(authService, router, alertService) {
        this.authService = authService;
        this.router = router;
        this.alertService = alertService;
        this.termsAndConditionsAgreed = false;
    }
    LoginComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(LoginComponent.prototype, "token", {
        get: function () {
            return this._token;
        },
        set: function (v) {
            this._token = v;
        },
        enumerable: true,
        configurable: true
    });
    LoginComponent.prototype.handleSubmit = function (event) {
        if (event && event.charCode === 13) {
            this.login();
        }
    };
    LoginComponent.prototype.login = function () {
        var _this = this;
        if (!this._token || this._token.trim() === "") {
            this.alertService.error("Enter in your client token to continue");
            return;
        }
        // if (!this.termsAndConditionsAgreed) {
        //   this.alertService.error("You must agree to the terms and conditions before continuing.");
        //   return;                                                                                                           
        // }
        this.authService.authenticateClient(this._token)
            .then(function (clientId) {
            _this.router.navigate(["/assessments/dashboard"]);
        })
            .catch(function (error) {
            console.error(error);
            _this.alertService.error(error.message);
        });
    };
    return LoginComponent;
}());
export { LoginComponent };



// WEBPACK FOOTER //
// ./src/app/login/login/login.component.ts.pre-build-optimizer.js